import React, { useState } from 'react';
import arrowIcon from '../../../assets/images/matchmaker-arrow.svg';
import chevronIcon from '../../../assets/images/matchmaker-chevron.svg';
import RelationshipSelectPopup, {
  getRelationshipLabel
} from './RelationshipSelectPopup';

/**
 * Step 2 of the "Be a Matchmaker" flow — details of the person being recommended.
 * Figma: "Recommend Someone" (1:5178) + "input field open" (32:10)
 */
const PersonDetailsComponent = ({
  goToNextStep,
  formValidation,
  values,
  handleChange,
  handleSelect
}) => {
  const [relOpen, setRelOpen] = useState(false);

  const next = () => goToNextStep(3);

  // A real <form> so Enter advances from any field, not just the last one.
  const onSubmit = (event) => {
    event.preventDefault();
    next();
  };

  const onSelectRelationship = (value) => {
    handleSelect('relationship', value);
    setRelOpen(false);
  };

  const relationshipLabel = getRelationshipLabel(values.relationship);

  return (
    <>
      <div className="matchmakerWrapper mm-recommend">
        <div className="mm-content mm-content-form">
          <h1 className="mm-title mm-title-form">
            Enter the details of the person you’d like to recommend.
          </h1>

          <form className="mm-form-wrap" onSubmit={onSubmit}>
            <div className="mm-form">
              <div className="mm-form-row">
                <div className="mm-field">
                  <input
                    className="mm-input"
                    type="text"
                    placeholder="First name"
                    value={values.firstName}
                    onChange={handleChange('firstName')}
                  />
                  <span className="validation-error">
                    {formValidation.firstName}
                  </span>
                </div>
                <div className="mm-field">
                  <input
                    className="mm-input"
                    type="text"
                    placeholder="Last name"
                    value={values.lastName}
                    onChange={handleChange('lastName')}
                  />
                  <span className="validation-error">
                    {formValidation.lastName}
                  </span>
                </div>
              </div>
              <div className="mm-form-row">
                <div className="mm-field">
                  <input
                    className="mm-input"
                    type="email"
                    placeholder="Enter Email ID"
                    value={values.email}
                    onChange={handleChange('email')}
                  />
                  <span className="validation-error">
                    {formValidation.email}
                  </span>
                </div>
              </div>
            </div>

            <p className="mm-section-label">Your relationship to this person</p>
            <div className="mm-form mm-form-gap-lg">
              <div className="mm-form-row">
                <div className="mm-field">
                  <button
                    type="button"
                    className="mm-select"
                    aria-haspopup="dialog"
                    aria-expanded={relOpen}
                    onClick={() => setRelOpen(true)}
                  >
                    <span
                      className={`mm-select-value${
                        relationshipLabel ? ' has-value' : ''
                      }`}
                    >
                      {relationshipLabel || 'Select Relationship'}
                    </span>
                    <img src={chevronIcon} alt="" />
                  </button>
                  <span className="validation-error">
                    {formValidation.relationship}
                  </span>
                </div>
              </div>
            </div>

            <div className="mm-actions">
              <button className="mm-next" type="submit" aria-label="Continue">
                <img src={arrowIcon} alt="" />
              </button>
            </div>
          </form>
        </div>
      </div>

      <RelationshipSelectPopup
        show={relOpen}
        value={values.relationship}
        onSelect={onSelectRelationship}
        onClose={() => setRelOpen(false)}
      />
    </>
  );
};

export default PersonDetailsComponent;
